var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",class:{ collapsed: _vm.collapsed }},[_c('div',{staticClass:"modal__close subtitle-1",on:{"click":_vm.close}},[_c('Icon',{attrs:{"name":"close"}})],1),_c('div',{staticClass:"modal__body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }